import React, { useEffect, useState } from 'react';
import './FeatureStyles.css';
import './NoVendorLockInFeature.css';

const NoVendorLockInAnimation = () => {
  const [activeOption, setActiveOption] = useState(0);

  const deploymentOptions = [
    { icon: 'LT', name: 'LambdaTest', desc: 'Cloud testing grid', color: 'purple', isLogo: true },
    { icon: 'BS', name: 'BrowserStack', desc: 'Real device cloud', color: 'orange', isLogo: true },
    { icon: 'SL', name: 'Sauce Labs', desc: 'Cross-browser testing', color: 'red', isLogo: true },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveOption(prev => (prev + 1) % deploymentOptions.length);
    }, 2500);
    return () => clearInterval(interval);
  }, [deploymentOptions.length]);

  return (
    <div className="feature-animation no-vendor-lockin">
      <div className="lockin-container">
        {/* Test Export Visual */}
        <div className="export-visual">
          <div className="test-file">
            <div className="file-header">
              <span className="file-icon">📄</span>
              <span className="file-name">tests.spec.ts</span>
            </div>
            <div className="file-content">
              <div className="code-line"><span className="keyword">describe</span>('Checkout', () =&gt; {'{'}</div>
              <div className="code-line indent"><span className="keyword">it</span>('completes purchase')</div>
              <div className="code-line">{'}'})</div>
            </div>
            <div className="export-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
              </svg>
              Export & Run Anywhere
            </div>
          </div>

          {/* Arrow */}
          <div className="export-arrow">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </div>

          {/* Deployment Options */}
          <div className="deployment-options">
            {deploymentOptions.map((option, idx) => (
              <div
                key={idx}
                className={`deployment-option ${activeOption === idx ? 'active' : ''} ${option.color}`}
              >
                <span className={`option-icon ${option.isLogo ? 'logo-badge' : ''} ${option.color}`}>{option.icon}</span>
                <div className="option-info">
                  <span className="option-name">{option.name}</span>
                  <span className="option-desc">{option.desc}</span>
                </div>
                {activeOption === idx && (
                  <span className="option-check">✓</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const NoVendorLockInFeature = {
  icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
    </svg>
  ),
  title: "No Vendor Lock-In",
  description: "Create with us. Run without us. Export standard Playwright tests to LambdaTest, BrowserStack, Sauce Labs, or any testing platform. No proprietary formats, no runtime dependencies, no strings attached.",
  animation: <NoVendorLockInAnimation />,
  docsLink: {
    url: "/documentation#web-cloud-providers",
    label: "Cloud Providers Documentation"
  }
};

export default NoVendorLockInFeature;
